import React, { useState, useEffect } from "react";
import "./home.css";
import hero from "./images/master-slides-01.jpg";
import hero2 from "./images/master-slides-02.jpg";
import hero3 from "./images/master-slides-03.jpg";
import story from './images/our-story-01.jpg';
import plato from "./images/bg-intro-01.jpg";
import stars from './images/intro-01.jpg';
import stars1 from './images/intro-02.jpg';
import stars2 from './images/intro-03.jpg';
import lunch from "./images/our-menu-01.jpg";
import lunch1 from "./images/our-menu-05.jpg";
import lunch2 from "./images/our-menu-07.jpg";
import lunch3 from "./images/our-menu-08.jpg";
import lunch4 from "./images/our-menu-10.jpg";
import lunch5 from "./images/our-menu-16.jpg";
import table from "./images/booking-01.jpg";
import blog1 from "./images/blog-01.jpg";
import blog2 from "./images/blog-02.jpg";
import blog3 from "./images/blog-03.jpg";
import { Link } from "react-router-dom";
import Menu from "./Menu";


const reviews = [
  { id:1, stars:stars, title:"Romantic Restaurant", text:"Phasellus lorem enim, luctus ut velit eget, convallis egestas eros.", learn:"Learn More →" },
  { id:2, stars:stars1, title:"Delicious Food", text:"Aliquam eget aliquam magna, quis posuere risus ac  nibh urna", learn:"Learn More →" },
  { id:3, stars:stars2, title:"Red Wines You Love", text:"Sed ornare ligula eget tortor tempor, quis porta tellus dictum.", learn:"Learn More →" },
];


const testimonials = [
  { id: 1, tart: blog1, title: "Best Places for Wine", text: "Sed ornare ligula eget tortor tempor, quis porta tellus dictum.", learn: "Continue Reading →" },
  { id: 2, tart: blog2, title: "Eggs and Cheese", text: "Phasellus lorem enim, luctus ut velit eget, convallis egestas eros.", learn: "Continue Reading →" },
  { id: 3, tart: blog3, title: "Style the Wedding Party", text: "Phasellus lorem enim, luctus ut velit eget, convallis egestas eros.", learn: "Continue Reading →" },
];


function Reviewlist({ reviews }) {
  return (
    <div className='rew'> 
      {reviews.map((rew) => ( 
        <div className="div-rew" key={rew.id}>
          <img src={rew.stars} className='rew-img' alt={rew.title} /> 
          <h2 className='rew-title'>{rew.title}</h2>
          <p className='rew-text'>{rew.text}</p>
         <Link to={"/about"}> <p className="rew-learn">{rew.learn}</p></Link>
        </div>
      ))}
    </div> 
  );
}


function Testimonials({ testimonials }) {
  return (
    <div className="rew">
      {testimonials.map((item) => (
        <div className="div-rew" key={item.id}>
          <img src={item.tart} className="rew-img" alt={item.title} />
          <h2 className="rew-title">{item.title}</h2>
          <p className="rew-text">{item.text}</p>
         <Link to={"/about"}> <p className="rew-learn">{item.learn}</p></Link>
        </div>
      ))}
    </div>
  );
}


const images = [hero, hero2, hero3];

const Home = () => {
  const [current, setCurrent] = useState(0);


  const [formData, setFormData] = useState({
    date: "",
    name: "",
    time: "",
    phone: "",
    people: 1,
    email: ""
  });

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(slideInterval);
  }, []);

  const galleryImages = [lunch, lunch1, lunch2, lunch3, lunch4, lunch5];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Booking data:", formData);
    alert("Booking submitted!");
    setFormData({ date:"", name:"", time:"", phone:"", people:1, email:"" });
  };

  return (
    <div className="App">
      <div className="hero-slider">
        {images.map((img, index) => (
          <div key={index} className={`slide ${index === current ? "active" : ""}`} style={{ backgroundImage: `url(${img})` }}></div>
        ))}
        <div key={current} className="hero-content fade-in">
          <h1 className="welcome">Welcome to</h1>
          <h1 className="highlight">Plato Palace</h1>
          <Link to={"/menu"}><button className="menu-btn">Menu</button></Link>
        </div>
        <div className="dots">
          {images.map((_, index) => (
            <span key={index} className={`dot ${index === current ? "active" : ""}`} onClick={() => setCurrent(index)}></span>
          ))}
        </div>
      </div>

      <div className="div2">
        <div className="right">
          <h1 className="italian">Italian Restaurant</h1>
          <h1 className="welcome1">Welcome</h1>
          <p className="ptf">
            Donec quis lorem nulla. Nunc eu odio mi. Morbi nec lobortis est. Sed fringilla, nunc sed imperdiet lacinia, nisl ante egestas mi, ac facilisis ligula sem id neque.
          </p>
        </div>
        <div className="image-container">
          <img src={story} className="img-zoom" alt="Our story" />
        </div>
      </div>

      <div className="plato-hero">
        <h1 className="italian">Discover</h1>
      </div>

      <Reviewlist reviews={reviews} />

<div className="container-ac">
  {galleryImages.map((img, index) => (
    <div className="item" key={index}>
      <img src={img} alt={`Menu item ${index + 1}`} />
      <Link to={"/menu"}><button className="img-btn">Menu</button></Link>
    </div>
  ))}
</div>


      <div className="movee">
        <h1 className="italian">Reservation</h1>
        <h1>Book a Table</h1>
      </div>
      <div className="Book-tablee">
        <form className="date-time" onSubmit={handleSubmit}>
          <div className="input-div">
            <h3>Date</h3>
            <input type="date" name="date" value={formData.date} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Name</h3>
            <input type="text" name="name" placeholder="Enter name" value={formData.name} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Time</h3>
            <input type="time" name="time" value={formData.time} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Phone</h3>
            <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>People</h3>
            <input type="number" name="people" placeholder="People" value={formData.people} onChange={handleChange} className="input" min="1" />
          </div>
          <div className="input-div">
            <h3>Email</h3>
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} className="input" />
          </div>
          <button type="submit" className="book-btn">Book Now</button>
        </form>

        <div className="tablee-img">
          <img src={table} alt="Table" />
        </div>
      </div>
      <Testimonials testimonials={testimonials} />
    </div>
  );
};

export default Home;
